<div class="w-full min-h-screen flex flex-col relative">
  <!-- Overlay de procesamiento -->
  @if (showProcessingOverlay) {
  <div class="fixed inset-0 bg-black/50 backdrop-blur-md flex items-center justify-center z-50">
    <div class="bg-white rounded-lg p-8 shadow-2xl flex flex-col items-center gap-4 max-w-md">
      <svg class="animate-spin h-12 w-12 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
      </svg>
      <h3 class="text-xl font-bold text-gray-900">Procesando llamada</h3>
      <p class="text-gray-600 text-center">Por favor espere mientras se analiza la transcripción. Este proceso puede tardar 5 minutos.</p>
    </div>
  </div>
  }

  <div class="flex justify-between items-center mb-6">
    <h1 class="text-2xl font-semibold text-gray-900">Mejora Prompt</h1>
  </div>

  <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
    <div class="flex items-center gap-4">
      <select
        [(ngModel)]="selectedAgentTypeId"
        (change)="onAgentTypeChange()"
        class="w-52 px-3 py-2 border border-gray-300 rounded-md text-sm font-medium bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 cursor-pointer shadow-sm">
        @for (agentType of agentTypes; track agentType.id) {
          <option [value]="agentType.id">{{agentType.name}}</option>
        }
      </select>
      @if (!promptId && loadedPage) {
      <button 
        (click)="showConfirmModal = true"
        [disabled]="!selectedAgentTypeId"
        class="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors text-sm font-semibold shadow disabled:opacity-60 disabled:cursor-not-allowed cursor-pointer flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
        </svg>
        <span>Crear Prompt Beta</span>
      </button>
      }
    </div>
  </div>

  <div class="flex flex-row gap-6 w-full flex-1 max-h-[700px]">
    <!-- Prompt Beta - Columna izquierda fija -->
    <div class="bg-white rounded-xl shadow-md border border-gray-200 p-6 flex flex-col w-[420px] min-w-[420px]">
      <div class="flex items-center justify-between mb-3">
        <h2 class="text-lg font-bold text-gray-900">Prompt Beta</h2>
        <div class="flex items-center gap-2">
          <label class="text-xs font-medium text-gray-600">Scoring min:</label>
          <input 
            type="number" 
            [(ngModel)]="minScore" 
            [disabled]="!promptId"
            placeholder="0-100"
            min="0"
            max="100"
            class="w-20 px-2 py-1 border border-gray-300 rounded text-sm text-center focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
          />
        </div>
      </div>
      <textarea
        [(ngModel)]="content"
        [disabled]="!promptId"
        class="bg-gray-50 rounded-lg p-4 border border-gray-300 flex-1 text-sm resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-900 font-mono mb-4 disabled:bg-gray-100 disabled:cursor-not-allowed"
        rows="20"></textarea>
      <div class="flex gap-2 mt-auto">
        <button
          (click)="savePrompt()"
          [disabled]="isSavingPrompt || !promptId || isTestingPrompt"
          class="flex-1 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors text-sm font-semibold shadow disabled:opacity-60 disabled:cursor-not-allowed cursor-pointer flex items-center justify-center gap-2">
          @if (isSavingPrompt) {
            <svg class="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
            </svg>
          }
          <span>Guardar</span>
        </button>
        <button
          [disabled]="!promptId"
          class="flex-1 px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700 transition-colors text-sm font-semibold shadow disabled:opacity-60 disabled:cursor-not-allowed cursor-pointer">
          A PROD
        </button>
      </div>
    </div>

    <!-- Panel derecho: Llamadas arriba + Comparación de feedbacks abajo -->
    <div class="flex-1 flex flex-col gap-6 overflow-hidden">
      <!-- Selector de llamada -->
      <div class="bg-white rounded-xl shadow-md border border-gray-200 p-4">
        <div class="flex items-center justify-between mb-3">
          <h2 class="text-md font-bold text-gray-900">Selecciona una llamada para analizar:</h2>
          <button 
            (click)="testPrompt()"
            [disabled]="isSavingPrompt || !selectedTranscription || !promptId || isTestingPrompt"
            class="px-3 py-1 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors text-sm font-semibold shadow disabled:opacity-60 disabled:cursor-not-allowed flex items-center gap-2">
            @if (isTestingPrompt) {
              <svg class="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
              </svg>
              <span>Analizando...</span>
            } @else {
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9.75 3.104v5.714a2.25 2.25 0 01-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 014.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0112 15a9.065 9.065 0 00-6.23-.693L5 14.5m14.8.8l1.402 1.402c1.232 1.232.65 3.318-1.067 3.611A48.309 48.309 0 0112 21c-2.773 0-5.491-.235-8.135-.687-1.718-.293-2.3-2.379-1.067-3.61L5 14.5" />
              </svg>
              <span>Analizar</span>
            }
          </button>
        </div>
        <!-- <div class="flex gap-2 mb-3">
          <input type="text" [(ngModel)]="filterText" placeholder="Buscar por título o fecha..." class="flex-1 px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
          <select [(ngModel)]="filterType" class="px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
            <option value="all">Tipo</option>
            @for (type of transcriptionTypes; track type) {
              <option [value]="type">{{ type === 'mobile' ? 'Móvil' : (type === 'phone' ? 'Centralita' : type) }}</option>
            }
          </select>
        </div> -->
        <div class="max-h-[160px] overflow-y-auto bg-gray-50 rounded-lg border border-gray-200 p-2">
          @for (transcription of filteredTranscriptions; track transcription.id) {
          <div (click)="selectedTranscription = transcription; feedbackProduction = ''; feedbackBeta = ''" 
               class="px-3 py-1.5 cursor-pointer transition-all border-l-4 rounded mb-1.5 flex items-center gap-3"
               [class.border-l-blue-600]="selectedTranscription?.id === transcription.id"
               [class.bg-blue-50]="selectedTranscription?.id === transcription.id"
               [class.border-l-transparent]="selectedTranscription?.id !== transcription.id"
               [class.hover:border-l-blue-400]="selectedTranscription?.id !== transcription.id"
               [class.hover:bg-gray-100]="selectedTranscription?.id !== transcription.id">
            <span class="text-xs font-semibold text-gray-500 whitespace-nowrap">{{transcription.start_time | date:'dd/MM/yyyy HH:mm'}}</span>
            <span class="text-sm text-gray-900">{{transcription.title}}</span>
          </div>
          }
          @if (isLoadingTranscriptions) {
          <div class="text-center py-2 text-sm text-gray-500">Cargando...</div>
          }
          @if (currentPage < totalPages && !isLoadingTranscriptions) {
          <button (click)="loadMoreTranscriptions()" class="w-full py-2 text-sm text-blue-600 hover:text-blue-700 font-medium">
            Cargar más
          </button>
          }
        </div>
      </div>

      <!-- Panel de comparación de resultados -->
      <div class="bg-white rounded-xl shadow-md border border-gray-200 p-6 flex flex-col overflow-hidden">
        <div class="flex items-center justify-between mb-4 flex-shrink-0">
          <h2 class="text-lg font-bold text-gray-900">Comparación de Resultados</h2>
          @if (analyzedTranscription) {
          <span class="text-sm text-gray-500">Llamada: <span class="font-semibold text-gray-900">{{analyzedTranscription.title}}</span></span>
          }
        </div>
        
        <div class="grid grid-cols-2 gap-4 flex-1 min-h-0">
          <!-- Feedback Producción -->
          <div class="flex flex-col border border-gray-300 rounded-lg overflow-hidden bg-gray-50 min-h-0">
            <div class="bg-gray-700 text-white px-4 py-3 flex items-center justify-between flex-shrink-0">
              <div class="flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-5 h-5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span class="font-bold">Producción</span>
              </div>
              @if (productionScore && !isTestingPrompt) {
              <span class="bg-white text-gray-700 rounded-full px-3 py-1 text-sm font-bold shadow">{{productionScore}}</span>
              }
            </div>
            <div class="p-4 flex-1 overflow-y-auto bg-white min-h-0">
              @if (isTestingPrompt) {
                <div class="flex items-center gap-2 h-full justify-center">
                  <svg class="animate-spin h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
                  </svg>
                  <span class="text-sm text-gray-500">Analizando...</span>
                </div>
              } @else if (feedbackProduction) {
                <div class="text-sm text-gray-800 prose prose-sm max-w-none" [innerHTML]="feedbackProduction"></div>
              } @else {
                <p class="text-sm text-gray-400 text-center h-full flex items-center justify-center">Selecciona una llamada y presiona "Analizar llamada" para ver el resultado</p>
              }
            </div>
          </div>

          <!-- Feedback Beta -->
          <div class="flex flex-col border border-gray-300 rounded-lg overflow-hidden bg-gray-50 min-h-0">
            <div class="bg-indigo-600 text-white px-4 py-3 flex items-center justify-between flex-shrink-0">
              <div class="flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-5 h-5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z" />
                </svg>
                <span class="font-bold">Beta (Nuevo)</span>
              </div>
              @if (betaScore && !isTestingPrompt) {
              <span class="bg-white text-indigo-600 rounded-full px-3 py-1 text-sm font-bold shadow">{{betaScore}}</span>
              }
            </div>
            <div class="p-4 flex-1 overflow-y-auto bg-white min-h-0">
              @if (isTestingPrompt) {
                <div class="flex items-center gap-2 h-full justify-center">
                  <svg class="animate-spin h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
                  </svg>
                  <span class="text-sm text-gray-500">Analizando...</span>
                </div>
              } @else if (feedbackBeta) {
                <div class="text-sm text-gray-800 prose prose-sm max-w-none" [innerHTML]="feedbackBeta"></div>
              } @else {
                <p class="text-sm text-gray-400 text-center h-full flex items-center justify-center">Selecciona una llamada y presiona "Analizar llamada" para ver el resultado</p>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- AI Suggestions -->
  <div class="mt-10">
    <h2 class="text-lg font-bold mb-2 flex items-center gap-2 text-gray-900">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        class="w-5 h-5">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="M12 18v-5.25m0 0a6.01 6.01 0 0 0 1.5-.189m-1.5.189a6.01 6.01 0 0 1-1.5-.189m3.75 7.478a12.06 12.06 0 0 1-4.5 0m3.75 2.383a14.406 14.406 0 0 1-3 0M14.25 18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 1 0-7.517 0c.85.493 1.509 1.333 1.509 2.316V18" />
      </svg>
      <span>Sugerencias IA</span>
    </h2>
    <div class="bg-blue-50 rounded-xl p-6 border border-blue-200 shadow">
      <p class="text-sm whitespace-pre-line text-gray-800">Contenido en desarrollo...</p>
    </div>
  </div>
</div>

<app-modal-confirm
  [isOpen]="showConfirmModal"
  [title]="'Crear Prompt Beta'"
  [message]="'No existe un prompt de pruebas para el tipo seleccionado, ¿Quieres crear uno nuevo?'"
  [type]="'info'"
  [buttons]="[
    { text: 'Cancelar', style: 'secondary', action: 'cancel' },
    { text: 'Confirmar', style: 'primary', action: 'confirm' }
  ]"
  (action)="onModalAction($event)"
></app-modal-confirm>

<app-modal-message [isOpen]="showMessageModal" [title]="messageModalTitle" [message]="messageModalMessage"
  [type]="messageModalType" (close)="closeMessageModal()"></app-modal-message>
